import { type PartnerAccountResponse } from '@/api/routes/partners/partners.api';
import { ScreenRoutes } from '@/types/router';

export type PartnerNavItem = 'events' | 'offers' | 'results' | 'links' | 'integration' | 'account';

export const PARTNER_NAV_ROUTES: Record<PartnerNavItem, ScreenRoutes> = {
  events: ScreenRoutes.EVENTS,
  offers: ScreenRoutes.OFFERS,
  results: ScreenRoutes.RESULTS,
  links: ScreenRoutes.LINKS,
  integration: ScreenRoutes.INTEGRATION,
  account: ScreenRoutes.ACCOUNT,
};

/**
 * Menu items (P17·b, P15). The category turns nothing on: Integração appears once the Bodyprint
 * team created the account's first media key. Links is always there (its page explains that the
 * team creates them). Conta closes the menu.
 */
export const getPartnerNavItems = (integrationEnabled: boolean): PartnerNavItem[] => [
  'events',
  'offers',
  'results',
  'links',
  ...(integrationEnabled ? (['integration'] as const) : []),
  'account',
];

/** The item whose section holds the path (`/offers/123/edit` → offers); null elsewhere. */
export const getActivePartnerNavItem = (pathname: string): PartnerNavItem | null =>
  (Object.entries(PARTNER_NAV_ROUTES) as [PartnerNavItem, string][]).find(
    ([, route]) => pathname === route || pathname.startsWith(`${route}/`),
  )?.[0] ?? null;

/** The menu shows for accounts that can use the portal: in review or approved. */
export const showsPartnerNav = (account?: PartnerAccountResponse | null): boolean =>
  account?.partner?.status === 'approved' || account?.partner?.status === 'pending_review';
